import React from 'react';
import { Chip, Paper, Stack, Tooltip } from '@mui/material';
import { IBaselineCoveragePeriod } from './forecastBaseline.models';

type Props = { periods: IBaselineCoveragePeriod[]; descending?: boolean };

class CoverageTimeline extends React.PureComponent<Props> {
  color(status: string): any {
    if (status === 'FACT') return 'success';
    if (status === 'FORECAST') return 'info';
    if (status === 'MISSING') return 'error';
    return 'default';
  }

  render() {
    const periods = [...(this.props.periods || [])].sort((a, b) =>
      this.props.descending === false ? String(a.periodcode).localeCompare(String(b.periodcode)) : String(b.periodcode).localeCompare(String(a.periodcode))
    );

    return (
      <Paper elevation={0} variant="outlined" sx={{ p: 1.5 }}>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {periods.map((p) => (
            <Tooltip key={p.periodcode} title={`${p.periodname}: ${p.status}${p.remarks ? ` — ${p.remarks}` : ''}`}>
              <Chip size="small" label={p.periodcode} color={this.color(p.status)} variant={p.status === 'FACT' || p.status === 'MISSING' ? 'filled' : 'outlined'} />
            </Tooltip>
          ))}
        </Stack>
      </Paper>
    );
  }
}

export default CoverageTimeline;
